import { Stack, Typography } from '@mui/material';
import { Permission } from '@procureai/permissions';
import { isNotEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';

import { BaseDomainType, DemandReference, filterInvalidLinks, I18nNamespace } from '~/common/types';
import { BaseLink } from '~/components/BaseLink/BaseLink';
import { HoverMenuProvider } from '~/components/HoverMenu';
import { SourceLinksButton } from '~/components/SourceLinksButton/SourceLinksButton';
import { RouteId } from '~/routes';

export interface PurchaseRequisitionSourceReferenceProps {
  reference: DemandReference;
}

export const PurchaseRequisitionSourceReference = ({ reference }: PurchaseRequisitionSourceReferenceProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'DemandDetailWidget' });
  const links = filterInvalidLinks(reference.links);
  const hasLinks = isNotEmpty(links);
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: 'center',
      }}
    >
      {reference.purchaseRequisitionId && reference.referenceId ? (
        <BaseLink
          link={{
            needs: { permission: Permission.BaseRequisitionList },
            to: RouteId.analyticsBase(BaseDomainType.PURCHASE_REQUISITION, reference.purchaseRequisitionId),
          }}
          variant="caption"
        >
          {reference.referenceId}
        </BaseLink>
      ) : (
        <Typography variant="body2">{reference.referenceId ?? t('noReference')}</Typography>
      )}
      {hasLinks ? (
        <HoverMenuProvider>
          <SourceLinksButton links={links} />
        </HoverMenuProvider>
      ) : null}
    </Stack>
  );
};
